export const vehiclesNotifications = [
  {
    id: 0,
    text: 'It’s time. Let’s go electric. Make the switch to electric motoring.',
  },
  {
    id: 1,
    text: 'What better way to experience electric than to try this EV?',
  },
  {
    id: 2,
    text: 'Book a test drive on this vehicle on Nevo today, it takes less than 90 seconds.'
  }
]